import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";

export default function SaveSearchDialog({
  open, onOpenChange,
  saveName, setSaveName,
  saveFreq, setSaveFreq,
  saveDigestMode, setSaveDigestMode,
  saveSmsEnabled, setSaveSmsEnabled,
  smsAvailable,
  filterSummary, saving, onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="gf-sharp border-zinc-200" data-testid="save-search-dialog">
        <DialogHeader>
          <DialogTitle className="font-display font-bold tracking-tight">Save this search</DialogTitle>
          <DialogDescription>
            We'll alert you by email when new grants matching these filters are posted.
          </DialogDescription>
        </DialogHeader>
        <Label className="gf-overline">Name</Label>
        <Input
          data-testid="save-search-name"
          value={saveName}
          onChange={(e) => setSaveName(e.target.value)}
          className="gf-sharp mt-2 border-zinc-300 bg-white"
          placeholder="Rural broadband alerts"
        />

        <Label className="gf-overline mt-4 block">Alert frequency</Label>
        <Select value={saveFreq} onValueChange={setSaveFreq}>
          <SelectTrigger data-testid="save-search-freq" className="gf-sharp mt-2 border-zinc-300 bg-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="gf-sharp">
            <SelectItem value="immediate">Immediate (hourly poll)</SelectItem>
            <SelectItem value="daily">Daily (09:00 UTC)</SelectItem>
            <SelectItem value="weekly">Weekly (Mondays 09:00 UTC)</SelectItem>
          </SelectContent>
        </Select>

        <Label className="gf-overline mt-4 block">Email format</Label>
        <Select value={saveDigestMode} onValueChange={setSaveDigestMode}>
          <SelectTrigger data-testid="save-search-digest" className="gf-sharp mt-2 border-zinc-300 bg-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="gf-sharp">
            <SelectItem value="summary">Rolled-up summary (one email per run)</SelectItem>
            <SelectItem value="per_finding">One email per new grant</SelectItem>
          </SelectContent>
        </Select>
        <p className="text-[11px] text-zinc-500 mt-2 leading-relaxed">
          {saveDigestMode === "per_finding"
            ? "You'll get a separate email for every new posting (best for fast-moving topics; capped at 25/run)."
            : "You'll get a single digest listing all new postings — quieter inbox."}
        </p>

        <div className="mt-4 border-t border-zinc-200 pt-4 flex items-start justify-between gap-3">
          <div>
            <Label className="gf-overline">SMS alerts for this search</Label>
            <p className="text-[11px] text-zinc-500 mt-1 leading-relaxed">
              Also send a text message when new grants match. Requires phone number + opt-in in Settings.
              {!smsAvailable && (
                <span className="block text-amber-700 mt-1">SMS is not enabled on your account yet — toggle ignored.</span>
              )}
            </p>
          </div>
          <input
            type="checkbox"
            data-testid="save-search-sms"
            checked={!!saveSmsEnabled}
            onChange={(e) => setSaveSmsEnabled(e.target.checked)}
            className="h-5 w-5 mt-1 cursor-pointer accent-blue-700"
          />
        </div>

        <div className="text-xs text-zinc-500 mt-3 font-mono">{filterSummary}</div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="gf-sharp border-zinc-300 uppercase font-bold tracking-wide">
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={saving} data-testid="save-search-confirm" className="gf-sharp bg-blue-700 hover:bg-blue-800 text-white font-bold uppercase tracking-wide">
            {saving ? "Saving…" : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
